import React from 'react';
import Modal from './Modal';
import './DeleteModal.css';

const MessageModal = props => {
    const modalStyle={
        top: '15vh'
    }
    return ( 
        <Modal
            show={props.show}
            onCancel={props.closeModal}
            // className="modal-learning"
            style={modalStyle}
            header={props.header}
            headerClass="modal-delete-header"
            contentClass="rtl py-0 px-0 bg-white rounded"

        >
            <div className="d-flex justify-content-center align-items-center h-100">
                <div>
                    <h5 className="font-weight-bold">{props.message}</h5>
                    <div className="text-center mt-4">
                        <button className="btn btn-success mx-1" 
                            onClick={() => {
                                props.closeModal();
                                props.confirmHandler(props.selectedId);
                            }}
                            style={{width:'70px'}}
                            
                        >
                            بله
                        </button>
                        <button className="btn btn-danger mx-1" 
                            onClick={() => props.closeModal()}
                            style={{width:'70px'}}
                        >
                            خیر
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
     );
}
 
export default MessageModal;